import React, { useCallback } from 'react';

import classNames from 'classnames';
import { useDropzone } from 'react-dropzone';

interface Props {
    children: React.ReactNode;
    onDrop: (files: File[]) => void;
}

const Dropzone = (props: Props) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onDrop = useCallback(props.onDrop, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
    });

    const handleClick = (event: React.MouseEvent) => {
        const dropzone = event.target as HTMLElement;
        // eslint-disable-next-line eqeqeq
        if (dropzone.tabIndex == -1) {
            event.stopPropagation();
        }
    };

    return (
        <div
            className={classNames({
                'uploader-attachment-drop-zone': true,
                'uploader-attachment-drop-zone--active': isDragActive,
            })}
            {...getRootProps({
                onClick: handleClick,
            })}
        >
            <input {...getInputProps()} />
            {props.children}
        </div>
    );
};

export default Dropzone;
